"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var Nfpa = /*#__PURE__*/function () {
  function Nfpa(opt) {
    _classCallCheck(this, Nfpa);

    this.flammability = null;
    this.health = null;
    this.reactivity = null;
    this.specialHazard = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(Nfpa, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      Object.keys(this).forEach(function (prop) {
        _this[prop] = opt[prop] !== undefined ? opt[prop] : null;
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Nfpa.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'nfpa.schema.json',
        type: 'object',
        properties: {
          flammability: {
            type: ['number', 'null']
          },
          health: {
            type: ['number', 'null']
          },
          reactivity: {
            type: ['number', 'null']
          },
          specialHazard: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Nfpa;
}();

module.exports = Nfpa;